import { create } from 'zustand';
import { DropdownItem } from '~/shared/components/MultipleSelector/models';

/* Table state */
type TableState = {
    query: string;
    selectedStatus: DropdownItem[];
    index: number;
    pageSize: number;
};

export const useOrderHistoryTableState = create<TableState>(() => ({
    query: '',
    selectedStatus: [],
    index: 0,
    pageSize: 10,
}));

export function setOrderHistoryTableQuery(query?: string) {
    useOrderHistoryTableState.setState({
        query,
    });
}

export function setOrderHistoryTableStatus(selectedStatus?: DropdownItem[]) {
    useOrderHistoryTableState.setState({
        selectedStatus,
    });
}

/* Table pagination */
type PaginationState = {
    pageIndex: number;
    pageSize: number;
};

type PaginationStore = PaginationState & {
    setPagination: React.Dispatch<React.SetStateAction<PaginationState>>;
};

export const usePaginationState = create<PaginationStore>((set) => ({
    pageIndex: 0,
    pageSize: 10,
    setPagination: (newState) => set(newState),
}));

export function setTablePagination(pageIndex: number, pageSize: number) {
    usePaginationState.setState({
        pageIndex,
        pageSize,
    });
}
